var hats = {
  getHatByID: function(id){
    var result;
    this.data.forEach(function(e){
      if (id == e.id){ result = e; }
    });
    return result;
  },
  loadHatByID: function(id, cb){
    amazeal.GetHat(id, function(hat){
      cb(hat);
    });
  },
  getHatByName: function(hat){
    var result;
    this.data.forEach(function(e){
      if (hat.getName() == e.getName()){ result = e; }
    });
    return result;
  },
  getName: function(hat){
    return `${hat.make} - ${hat.model} - ${hat.variant}`;
  },
  data: [],
  load: function(cb){
    var _this = this;
    amazeal.GetAllHats(function(hats){
      _this.data = hats;
      cb();
    });
  }
}
console.log("Loaded Hats.js");